/**
 * Le champ « Nom complet » est-il affiché dans le formulaire du donateur ?
 * Règle UNIQUE de `DonateDonorForm` : sans champs configurés, tout est
 * affiché ; sinon seulement si « fullname » est dans la liste. Masqué pour un
 * don anonyme.
 *
 * Sert aussi au bouton Bancontact (21/10) : quand ce champ est affiché, c'est
 * lui qui donne le nom du titulaire — Bancontact ne le redemande pas.
 */
export function champNomAffiche(
  customFields: ReadonlyArray<{ type: string }> | null | undefined,
  anonyme = false,
): boolean {
  if (anonyme) return false;
  return !customFields || customFields.some((f) => f.type === "fullname");
}
